<template>
  <div class="multiple-text-input clearfix">
    <div class="form-group row">
      <div class="col-sm-12">
        <label>
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </label>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12">
        <template v-for="(input, index) in textInputs">
          <text-input
            :key="index"
            :options="input"
            @input="saveValue($event, index)"
            :value="input.value">
          </text-input>
          <div class="text-right" :key="index + 'button'">
            <button
              class="btn btn-danger btn-sm mb-3"
              @click.prevent="removeInput(index)">
              <span class="fa fa-times fa-fw"></span> Remove
            </button>
          </div>
        </template>
      </div>
      <div class="col-sm-9 offset-sm-3">
        <button
          class="btn btn-info"
          @click.prevent="addInput()">
          <span class="fa fa-plus fa-fw"></span> Add {{ options.labelSingular }}
        </button><br/>
        <div :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
import TextInput from '@/components/inputs/TextInput'

export default {
  name: 'MultipleTextInput',
  components: {
    TextInput
  },
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          value: [],
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      textInputs: [],
      maxChargeAmount: false
    }
  },
  mounted () {
    if (this.value.length) {
      for (let val of this.value) {
        this.addInput(val)
      }
      this.validate()
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (!this.textInputs.length) {
        return 'You did not add any ' + this.options.label
      } else {
        return 'You did not fill out all ' + this.options.label + ' correctly'
      }
    }
  },
  methods: {
    addInput (val = '') {
      this.isValid = true
      let input = {
        label: this.options.subLabel,
        type: 'text',
        value: val
      }
      this.textInputs.push(Object.assign({}, input))
    },
    removeInput (index) {
      this.textInputs.splice(index, 1)
      this.value.splice(index, 1)
      this.$emit('input', this.value)
    },
    saveValue (val, index) {
      this.isDirty = true
      this.value.splice(index, 1, val)
      this.textInputs[index].value = val
      this.$emit('input', this.value)
    },
    validate () {
      this.isDirty = true
      if (!this.textInputs.length && this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
        for (let child of this.$children) {
          child.isDirty = true
          if (!child.isValid) this.isValid = false
        }
        this.$emit('input', this.value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/MultipleTextInput.vue